import SystemConfigurationComponent from '../Components/SystemConfiguration/SystemConfigurationComponent';

function SystemConfigurationPage() {
  return <SystemConfigurationComponent />;
}

export default SystemConfigurationPage;
